<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Holiday Date'"></Teranet-PageTitle>
    <form [formGroup]="holidayDateFormGroup" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Lookup Holiday Date'" [IconName]="'search'"></Teranet-ClientTitle>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <div class="icon-button">
              <button mat-button (click)="addHolidayDate()">
                <div class="btnicon">
                  <fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
                </div>
                <div class="btntext">Add</div>
              </button>
            </div>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <Teranet-YearPicker [disabled]="false"
                                [label]="'Year'"
                                [required]="true"
                                formControlName="year"></Teranet-YearPicker>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button-lg" type="reset">Reset</button>
            <button mat-raised-button class="theme-button-lg" (click)="onLookup()">Lookup</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="holidayDateModels"
                            [gridName]="'holidayDate'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="gridDefaultSettings()"
                            [isFinishLoading]="true"
                            [isExportExcel]="false"
                            [pageName]="'holidayDate'"></Teranet-CustomizedGrid>
  </div>
</div>
